import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { Detalle_Evaluacion_IndicadorEntity, EvaluacionEntity, IndicadorEntity } from '../../funciones/AlertaTemprana';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { GraphATService } from '../../../services/riesgo-credito/riesgos/graph/graph-at.service';
import { periodos } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { indicadores } from '../idsTablas';
import { GanttRow, GanttColumnKey } from '../../../components/gantt/models/headers-type.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-planes',
  templateUrl: './planes.component.html',
  styleUrl: './planes.component.css'
})
export class PlanesComponent {
  public Filters = FiltersM;
  /*Obtención de datos consultas*/
  private indicadorEntity = new IndicadorEntity;
  private evaluacionEntity = new EvaluacionEntity;
  /**
   * Periodos
   */
  public anios = [];
  public cadenaEvaluacion: any = [];

  /**
   * Modales
   */
  modal1 = false;
  modal2 = false;
  modal3 = false;
  /**
   * Formularios
   */
  //Proyectos
  public formProy = new FormGroup({
    name: new FormControl('',[Validators.required]),
    responsible: new FormControl('',[Validators.required]),
    relacionId: new FormControl('',[Validators.required]),
  });
  //Actividades
  formActi = new FormGroup({
    name: new FormControl('',[Validators.required]),
    startDate: new FormControl('',[Validators.required]),
    endDate: new FormControl('',[Validators.required]),
    responsible: new FormControl('', [Validators.required]),
  });
  //Adicionales
  formAdit = new FormGroup({
    name: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
  },);
  /**
   * Variables modales
   */
  edit = false;
  //Adicionales
  gantAditionalId;
  /**
   * 
   */

  indicadores = [];
  ganttRows: GanttRow[] = [];
  responsibles = [];

  constructor(
    readonly dataService: DataService,
    readonly cookieService: CookieService,
    readonly translate: TranslateService,
    readonly apollo: Apollo,

    private graphAtService: GraphATService,
  ){
    this.evaluacionEntity = new EvaluacionEntity;
    this.indicadorEntity = new IndicadorEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.indicadorEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.getEvaluacion();
  }

  /*Consultas*/
  private async getEvaluacion(){
    try{
      const data = await this.graphAtService.getEvaluaciones(this.evaluacionEntity.Id_Plantilla);      
      var aux = [];
      for(const per of data){
        if(per.idInstitucion === this.evaluacionEntity.Id_Institucion){
          aux.push(per);
        }
      }
      const anios = [...new Set(
        aux.map(f => moment(f.fechaContable).year())
      )].map(anio => ({
        name: anio,
        check: false,
      }));
      const anioSeleccionado = anios.reduce((anterior, actual) =>
        Math.abs(actual.name - moment().year()) < Math.abs(anterior.name - moment().year())
          ? actual
          : anterior
      );

      anioSeleccionado.check = true;
      this.anios = anios;
      
      this.cadenaEvaluacion = this.anios.find(e => e.check===true);
      this.obtenerData();
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  /**
   * 
   */
  responsables = [
    'Jefatura de Riesgos',
    'Gerencia de Créditos',
    'Gerencia de Créditos',
    'Asesoría Legal / Contabilidad',
    'Comité de Créditos',
    'Gerencia Administrativa',
    'Gerencia General',
    'Gerencia Administrativa',
    'Contabilidad',
    'Gerencia Comercial',
    'Comité de Inversiones',
    'Gerencia Comercial / TI',
    'Gerencia Financiera',
    'Gerencia Comercial',
    'Contabilidad',
    'Gerencia Financiera',
    'Gerencia General',
    'Riesgos / Friedrich LATAM',
  ]
  async obtenerData(){
    const data = await this.graphAtService.getDataIndicadores(this.evaluacionEntity.Id_Plantilla);
    const indicadores = data.filter(i => i.nivel === 3).map(e => {
      return {
        id: e.id,
        name: e.descripcion,
      }
    })
    this.indicadores = indicadores;
    this.responsibles =  [ ...new Set(
        this.responsables.map(f => f)
      )].map( (r, i) => {
        return {
          id: i,
          roleName: r
        }
      });

    for(var i = 0; i<=5; i++){
      this.ganttRows.push({
        id: this.indicadores[i].id,
        nombre: this.indicadores[i].name,
        inicio: null,
        dias: null,
        fin: null,
        expandido: true,
        series: [],
      })
    }

    this.ganttRows = this.getProyectos();

    this.ganttRows.forEach( (p, j) => {
      if (p.series.length) {
        p.inicio = moment.min(
          p.series.map(s => moment(s.inicio))
        );

        p.fin = moment.max(
          p.series.map(s => moment(s.fin))
        );

        p.dias = p.fin.diff(p.inicio,'days');
      }
    });
  }
  proyectos = [
    {
      ind: 'Indice de Morosidad', 
      acti: [
        {
          act: 'Diagnóstico de la cartera vencida por tramos de mora, agencia, producto y analista',
          res: 'Jefatura de Riesgos',
          ini: '03/11/2025',
          fin: '19/12/2025'
        },
        {
          act: 'Conformar unidad de cobranza con esquema de incentivos por recuperación',
          res: 'Gerencia de Créditos',
          ini: '05/01/2026',
          fin: '27/02/2026'
        },
        {
          act: 'Campaña de reestructuración y refinanciación para mora de 61 a 180 días',
          res: 'Gerencia de Créditos',
          ini: '02/02/2026',
          fin: '31/07/2026'
        },
        {
          act: 'Gestión judicial y castigo de cartera > 360 días conforme a la normativa del INCOOP',
          res: 'Asesoría Legal / Contabilidad',
          ini: '02/03/2026',
          fin: '30/09/2026'
        },
        {
          act: 'Actualizar la política de crédito (capacidad de pago, límites de endeudamiento y garantías)',
          res: 'Comité de Créditos',
          ini: '05/01/2026',
          fin: '30/04/2026'
        },
      ],
      name: 'Recuperación de cartera'
    },
    {
      ind: 'Indice de gastos administrativos',
      acti: [
        {
          act: 'Análisis detallado de los gastos de administración 2025 e identificación de partidas extraordinarias',
          res: 'Gerencia Administrativa',
          ini: '03/11/2025',
          fin: '15/12/2025'
        },
        {
          act: 'Presupuesto 2026 con techo de gastos de administración del 65% de los ingresos financieros',
          res: 'Gerencia General',
          ini: '01/12/2025',
          fin: '30/01/2026'
        },
        {
          act: 'Renegociar contratos de servicios (seguridad, enlaces de datos, alquileres)',
          res: 'Gerencia Administrativa',
          ini: '02/02/2026',
          fin: '30/06/2026'
        },
        {
          act: 'Tablero mensual de gastos por centro de costo',
          res: 'Contabilidad',
          ini: '02/03/2026',
          fin: '29/05/2026'
        },
      ],
      name: 'Eficiencia de gastos'
    },
    {
      ind: 'Participación de cartera',
      acti: [
        {
          act: 'Plan comercial de colocación con metas por agencia y oficial de crédito',
          res: 'Gerencia Comercial',
          ini: '01/12/2025',
          fin: '27/02/2026'
        },
        {
          act: 'Reasignar gradualmente el excedente de inversiones financieras hacia cartera de créditos',
          res: 'Comité de Inversiones',
          ini: '15/01/2026',
          fin: '30/10/2026'
        },
        {
          act: 'Lanzar dos productos: crédito MIPYME y consumo con débito automático',
          res: 'Gerencia Comercial / TI',
          ini: '02/02/2026',
          fin: '30/06/2026'
        },
      ],
      name: 'Colocación y productividad'
    },
    {
      ind: 'Costo financiero depositos a plazo fijo',
      acti: [
        {
          act: 'Revisar el tarifario de plazo fijo y escalonar tasas por plazo y monto',
          res: 'Gerencia Financiera',
          ini: '05/01/2026',
          fin: '31/03/2026'
        },
        {
          act: 'Campaña de captación de ahorro a la vista',
          res: 'Gerencia Comercial',
          ini: '01/04/2026',
          fin: '30/09/2026'
        },
      ],
      name: 'Costo de fondeo'
    },
    {
      ind: 'Rendimiento del Capital',
      acti: [
        {
          act: 'Analizar la recurrencia de los otros ingresos',
          res: 'Contabilidad',
          ini: '03/11/2025',
          fin: '19/12/2025'
        },
        {
          act: 'Proyección financiera 2026 sin ingresos extraordinarios',
          res: 'Gerencia Financiera',
          ini: '05/01/2026',
          fin: '27/02/2026'
        },
      ],
      name: 'Sostenibilidad del resultado'
    },
    {
      ind: 'Indice de gastos de gobernabilidad',
      acti: [
        {
          act: 'Comité mensual de seguimiento del plan con informe al Consejo de Administración',
          res: 'Gerencia General',
          ini: '03/11/2025',
          fin: '30/10/2026'
        },
        {
          act: 'Corregir los parámetros del semáforo en Aleema (solvencia, liquidez, morosidad, activos improductivos)',
          res: 'Riesgos / Friedrich LATAM',
          ini: '03/11/2025',
          fin: '30/01/2026'
        }
      ],
      name: 'Gobierno y seguimiento'
    },
  ]
  getProyectos(){

    const aux: GanttRow[] = this.proyectos.map(p =>{
      const i = this.indicadores.find(i => i.name === p.ind);
      return {
        nombre: p.name,
        id: i.id,
        responsable: '',
        inicio: null,
        dias: null,
        fin: null,
        expandido: true,
        series: p.acti.map( (a, j) => {
          const r = this.responsibles.find(re => re.roleName === a.res);
          const fecha1 = moment(a.ini, 'DD/MM/YYYY');
          const fecha2 = moment(a.fin, 'DD/MM/YYYY');
          return {
            nombre: a.act,
            id: j,
            responsable: r.roleName,
            inicio: fecha1,
            dias: fecha2.diff(fecha1, 'days'),
            fin: fecha2,
            
          }
        }),
      }
    });

    return aux;
  }
  /**
   * Cambios de periodos
   */
  cambioPeriodo(per){
    this.anios.forEach( a => {
      a.check = a.name === per.name;
    });
    this.cadenaEvaluacion = this.anios.find(e => e.check===true);
  }
  /**
   * Modales
   */
  closeModal(){
    this.modal1 = false;
    this.modal2 = false;
    this.modal3 = false;
    this.edit = false;
  }
  /**
   * Metodos de guardado
   */
  //Proyectos
  saveInformationProyects(){

  }
  //Actividades
  saveInformationActivities(){

  }
  //Adicionales
  saveInformationAditional(){

  }
  /**
   * Eventos gantt
   */
  eventosHeaders(event: any){
    if(event === 'funcionalidades'){
      this.modal1 = true;
    }else{

    }
  }
  async eventosTablas(event: any){
    switch(event.encabezado){
      case 'edit':
        if(event.nivel === 'proyecto'){
          this.formProy.controls.name.setValue(event.elemento.nombre);
          this.formProy.controls.relacionId.setValue(event.elemento.id);

          this.modal1 = true;
          this.edit = true; 
        }else{
          const r = this.responsibles.find(re => re.roleName === event.elemento.responsable);
          this.formActi.controls.name.setValue(event.elemento.nombre);
          this.formActi.controls.responsible.setValue(r.id);
          this.formActi.controls.startDate.setValue(event.elemento.inicio.format('YYYY-MM-DD'));
          this.formActi.controls.endDate.setValue(event.elemento.fin.format('YYYY-MM-DD'));

          this.modal2 = true;
          this.edit = true; 
        }
        break;
      case 'add':
        if(event.nivel === 'proyecto'){
          this.modal1 = true;
        }else{
          this.modal2 = true;
        }
        break;
      case 'delete':
        if(event.nivel === 'proyecto'){
          const acep =  await messages.confirmationSave('Deseas eliminar este proyecto',event.elemento.nombre, this.translate);
          if(acep){
            this.ganttRows = this.ganttRows.filter(e => e.id !== event.elemento.id);
            messages.succesMessageGraph('Proyecto eliminado');
          }
        }else{
          const acep = await messages.confirmationSave('Deseas eliminar esta actividad',event.elemento.nombre, this.translate);
          if(acep){
            const p = this.ganttRows.find(e => e.id === event.elemento.idPadre);
            p.series = p.series.filter(a => a.id !== event.elemento.id);

            this.ganttRows.forEach( (p, j) => {
              if (p.series.length) {
                p.inicio = moment.min(
                  p.series.map(s => moment(s.inicio))
                );

                p.fin = moment.max(
                  p.series.map(s => moment(s.fin))
                );
              }
              p.dias = p.fin.diff(p.inicio,'days');
            });
            messages.succesMessageGraph('Proyecto eliminado');
          }
        }
        break;
    } 
  }
}
